<template>
  <button
    type="button"
    class="auth-theme-btn"
    :class="[
      `auth-theme-btn--${variant}`,
      {
        'auth-theme-btn--block': block,
        'auth-theme-btn--disabled': disabled || loading,
      },
    ]"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <van-loading v-if="loading" size="18" color="currentColor" />
    <app-image v-else-if="icon" :src="icon" alt="" />
    <span><slot /></span>
  </button>
</template>

<script setup>
defineProps({
  variant: {
    type: String,
    default: "primary",
  },
  block: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: "",
  },
});

defineEmits(["click"]);
</script>

<style scoped lang="scss">
.auth-theme-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 14px 16px;
  border: none;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;

  &--block {
    width: 100%;
  }

  &--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .app-image {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    object-fit: contain;
  }

  &--primary {
    color: #ffffff;
    background: var(--wp-color-theme);
    box-shadow: 0 4px 4px #cddcff;
  }

  &--secondary {
    color: var(--wp-color-theme);
    background: var(--wp-color-button-2);
  }

  &--cancel {
    color: #333333;
    background: #f0f0f0;
  }
}
</style>
